<style lang="scss" scoped>
.dialog-choose-wrap {
  padding-bottom: 50px;
  overflow: hidden;

  .item-card {
    // width: 200px;
    border: 1px solid $border-color-base;
    line-height: 60px;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    float: left;
    padding: 0 20px;
    margin-right: 20px;
    background-color: $bg-color-base-dark;

    &:hover {
      background-color: $color-primary-light;
    }

    &:active {
      opacity: 0.8;
    }

    img {
      width: 40px;
      vertical-align: middle;
      margin-right: 10px;
      margin-left: 10px;
    }

    span {
      display: inline-block;
      // max-width: 100px;
      padding-right: 10px;
    }
  }
}
</style>
<template>
  <el-dialog title="选择企业类型"
    v-loading="pageLoading"
    top="3vh"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false" :close-on-press-escape="false"
    width="485px">
    <div class="dialog-choose-wrap">
      <div class="item-card" @click="chooseApprovalType(item)"
        v-for="item in tableList" :key="item">
        <span>{{companyTypes.constMap.idMap[item].name}}</span>
      </div>
      <div v-if="!pageLoading && tableList && tableList.length <= 0"
        style="min-height: 100px; line-height: 100px;">
        无权限，请联系管理员
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCompanyTypes } from '@/api/company'
import { companyTypes } from '@/const'

export default {
  name: 'choose-commpany-Type',
  data() {
    return {
      dialogVisible: false,
      pageLoading: true,
      tableList: [],
      companyTypes
    }
  },
  mounted() {
    this.$on('open', () => {
      this.dialogVisible = true
      this.initPage()
    });
  },
  methods: {
    chooseApprovalType(typeId) {
      this.$emit('choose', typeId)
      this.dialogVisible = false
    },
    initPage() {
      this.pageLoading = true
      this.tableList = []
      getCompanyTypes().then(res => {
        if (res.code != 0) throw new Error(res.message)
         this.tableList = res.data || []
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.pageLoading = false
      })
    }
  }
}
</script>
